import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import arrowTick from "../../../asset/images/tickarrow.svg";
import DeleteIcon from "../../../asset/images/deleteicon.svg";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import axios from "axios";
import { toast } from "react-toastify";
import {
  decryptData,
  encryptData,
  mobileVal,
  onlyNumber,
  validatePan,
} from "../../../CommonMethhods/CommonMethods";
import { useNavigate } from "react-router-dom";
import SmallLoader from "../../Common/smallLoader";
import { partner_Admin } from "../../../Configuration/Partner_URL";

const PersonalDetails = () => {
  const storeToken = localStorage.getItem("ssoToken");

  const [deleteTransaction, setDeleteTransaction] = useState(false);
  const [DeleteRecords, setDeleteRecords] = useState(false);
  const [showUlResponse, setShowUlResponse] = useState(false);
  const [multiVal, setMultiVal] = useState([]);
  const [segmentData, setSegmentData] = useState("");
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();

  if (storeToken == null) {
    window.location.replace("/");
  }

  const segmentValue = [
    {
      segment: "NSE Cash",
    },
    {
      segment: "BSE Cash",
    },
    {
      segment: "NSE Derivatives",
    },
    {
      segment: "BSE Derivatives",
    },
  ];

  const errorSchema = Yup.object().shape({
    nameValid: Yup.string().required("Please enter full name"),
    panValid: Yup.string()
      .required("Please enter PAN number")
      .matches(
        /^[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}$/,
        "This is not valid Pan Number"
      ),
    mobileValid: Yup.string()
      .required("Please enter mobile number")
      .matches(
        /^[6-9]{1}[0-9]{9}$/,
        "Please enter valid number,Initial digit must range from 6 -9 "
      ),
    emailValid: Yup.string()
      .required("Please enter email id")
      .matches(
        /^\w+([\.-]?\w+)*@[A-Za-z]{1}\w+([\.-]?\w+)*(\.[A-Za-z]{1}\w{1,5})+$/,
        "Enter valid email id"
      ),
    dobValid: Yup.string().required("Please enter dob"),
    // shortNameValid: Yup.string().required("Please enter short name"),
    genderValid: Yup.string().required("Please enter gender"),
    pinCodeValid: Yup.string().required("Please enter pincode"),
    cityValid: Yup.string().required("Please enter city"),
    stateValid: Yup.string().required("Please enter state"),
    add1Valid: Yup.string().required("Please enter block number/street"),
    add2Valid: Yup.string().required("Please enter landmark"),
    add3Valid: Yup.string().required("Please enter address"),
    citizenValid: Yup.string().required("Please enter citizenship"),
    accNumber: Yup.string().required("Please enter account number"),
    accType: Yup.string().required("Please enter account type"),
    ifscCode: Yup.string()
      .required("Please enter IFSC code")
      .matches(
        /^[A-Z]{4}0[A-Z0-9]{6}$/,
        "*Please Enter valid IFSC code without white space"
      )
      .transform((value) => value.toUpperCase()),
    bankName: Yup.string().required("Please enter bank name"),
    branchName: Yup.string().required("Please enter branch name"),
    micrNumber: Yup.string().required("Please enter MICR number"),
    clCode: Yup.string().required("Please enter client code"),
    segmentType: Yup.string().required("Please enter segment type"),
    partnerCode: Yup.string().required("Please enter partner code"),
  });

  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    clearErrors,
    reset: resetForm,
    setError,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(errorSchema),
  });

  const checkBoxClick = (e, data) => {
    if (e?.target?.checked) {
      setMultiVal((prev) => [...prev, data.segment]);
      
    } else {
      let array = [...multiVal];
      let index = array.indexOf(data.segment);
      if (index !== -1) {
        array.splice(index, 1);
      }
      setMultiVal(array);
    }
  };

  const branchCodeSet = (data) => {
    let segmentData = data.join(",");

    if (data.length > 0) {
      clearErrors("segmentType");
    } else {
      setError("segmentType", {
        types: {
          required: "Please enter segment type",
        },
      });
    }
    setValue("segmentType", data.join(","));
    setSegmentData(data.join(","));
  };

  const resetAllFields=()=>{
    resetForm({
      nameValid: "",
      panValid: "",
      mobileValid: "",
      emailValid: "",
      dobValid: "",
      fname: "",
      genderValid: "",
      pinCodeValid: "",
      cityValid: "",
      stateValid: "",
      add1Valid: "",
      add2Valid: "",
      add3Valid: "",
      citizenValid : "",
      accNumber: "",
      accType: "",
      ifscCode: "",
      bankName: "",
      branchName: "",
      micrNumber: "",
      clCode: "",
      segmentType: "",
      partnerCode: "",
    });
  }

  const getClientFormData = async (data) => {
    setLoader(true);
    let approReq = {
      cname: data.nameValid,
      pan: data.panValid,
      mobile: data.mobileValid,
      emailid: data.emailValid,
      dob: data.dobValid.split("-").reverse().join("-"),
      // fname: data?.shortNameValid,
      gender: data.genderValid,
      zipcode: data.pinCodeValid,
      cityid: data.cityValid,
      stateid: data.stateValid,
      address1: data.add1Valid,
      address2: data.add2Valid,
      address3: data.add3Valid,
      nationality: data.citizenValid,
      account_no: data.accNumber,
      account_type: data.accType,
      ifsc: data.ifscCode,
      bank_name: data.bankName,
      bank_branch_name: data.branchName,
      micr_code: data.micrNumber,
      onl_id: data.clCode,
      trading_preference: segmentData,
      utm_campaign: data.partnerCode,
    };
    let payloadApproved = encryptData(JSON.stringify(approReq));
    try {
      const getValues = await axios.post(
        partner_Admin.GetClientForm_URL,
        payloadApproved,

        {
          headers: {
            "Content-Type": "text/plain",
            Authorization: `Bearer ${storeToken}`,
          },
        }
      );
      const formData = decryptData(getValues?.data);
      let decryptedForm = JSON.parse(formData);

      if (decryptedForm?.status === 0) {
        const reponse = decryptedForm?.data?.info;
        resetAllFields();
        toast.success(decryptedForm?.data?.message);
      } else {
        console.log(decryptedForm, "err");
        toast.error(decryptedForm?.message);
      }
    } catch (error) {
      console.log("decryptedForm error",error)
      console.log(error);
    } finally {
      setLoader(false);
    }
  };

  const onFinalSubmit = (data) => {
    console.log(data, "submitData");
    getClientFormData(data);
  };

  const NameInput = (event) => {
    const currentValue = event.target.value;
    const uppercasedValue = currentValue.toUpperCase();
    event.target.value = uppercasedValue;
  };

  useEffect(() => {
    branchCodeSet(multiVal);
  }, [multiVal]);

  const handlePanPaste = (e) => {
    e.preventDefault();
    const pastedText = e.clipboardData.getData("text").toUpperCase().trim();
    const cleanText = pastedText.replace(/[^A-Z0-9]/g, "").slice(0, 10);
    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
    if (cleanText.length === 10 && panRegex.test(cleanText)) {
      setValue("panValid", cleanText, { shouldValidate: true });
    } else {
      setValue("panValid", "", { shouldValidate: true });
    }
  };

  const handlePasteDigits = (fieldName, maxLength) => (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("Text");
    const onlyNumbers = pastedData.replace(/\D/g, "").slice(0, maxLength);
    if (onlyNumbers === "") return;
    setValue(fieldName, onlyNumbers, { shouldValidate: true });
    e.target.value = onlyNumbers;
  };

  const handlePaste = (fieldName) => (e) => {
    e.preventDefault();
    const pastedText = e.clipboardData.getData("text");
    const clean = pastedText
      .replace(/[^a-zA-Z\s]/g, "")
      .replace(/\s+/g, " ")
      .trim();
  
    const currentVal = getValues(fieldName) || "";
    let newValue = `${currentVal} ${clean}`.replace(/\s+/g, " ").trim();
  
    newValue = newValue.slice(0, 40);
  
    setValue(fieldName, newValue, { shouldValidate: true });
    e.target.value = newValue;
  };

  const handlePasteEmail = (e) => {
    e.preventDefault();
    let pastedText = e.clipboardData.getData("text");
    let clean = pastedText.replace(/[^a-zA-Z0-9@.]/g, "");
    const atIndex = clean.indexOf("@");
    if (atIndex !== -1) {
      const beforeAt = clean.slice(0, atIndex + 1);
      const afterAt = clean.slice(atIndex + 1).replace(/@/g, "");
      clean = beforeAt + afterAt;
    }
    clean = clean.replace(/\.{2,}/g, ".");
    clean = clean.replace(/\.@/g, "@");
    clean = clean.replace(/^[@.]+|[@.]+$/g, "");
  
    setValue("emailValid", clean, { shouldValidate: true });
  };

  const handlePastePincode = (e) => {
    e.preventDefault();
  
    const pastedText = e.clipboardData.getData("text");
    let clean = pastedText.replace(/\D/g, "").trim();
    clean = clean.slice(0, 6);
      if (clean === "") return;
      setValue("pinCodeValid", clean, { shouldValidate: true });
    e.target.value = clean;
  };

  const handlePasteAddress = (fieldName) => (e) => {
    e.preventDefault();
    const pastedText = e.clipboardData.getData("text");

    let clean = pastedText
      .replace(/[^a-zA-Z0-9#&/,\s]/g, "") 
      .replace(/\s+/g, " ")       
      .trim();                            
  
    if (clean === "") return;
  
    setValue(fieldName, clean, { shouldValidate: true });
    e.target.value = clean;
  };

  const handlePasteAccountNumber = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("Text");
    const onlyNumbers = pastedData.replace(/\D/g, "").slice(0, 20);
    if (onlyNumbers === "") return;
    setValue("accNumber", onlyNumbers, { shouldValidate: true });
    e.target.value = onlyNumbers;
  };

  const handlePasteIFSC = (e) => {
    e.preventDefault();
    const pastedText = e.clipboardData.getData("text").toUpperCase().trim();
    const alphanumeric = pastedText.replace(/[^A-Z0-9]/gi, "");
    const ifscMatch = alphanumeric.match(/^([A-Z]{4})([0-9]{1,7})/);
  
    if (ifscMatch) {
      const cleanIFSC = ifscMatch[1] + ifscMatch[2].padEnd(7, "0");
      const finalValue = cleanIFSC.slice(0, 11);
      setValue("ifscCode", finalValue, { shouldValidate: true });
      e.target.value = finalValue;
    } else {
      setValue("ifscCode", "", { shouldValidate: true });
    }
  };

  const handlePasteCodes = (fieldName) => (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("Text");
    const clean = pastedData
      .replace(/[^a-zA-Z0-9]/g, "")
      .toUpperCase()
      .slice(0, 10);
  
    if (clean === "") return;
    setValue(fieldName, clean, { shouldValidate: true });
    e.target.value = clean;
  };

  const currentDate = new Date();
    const yyyy = currentDate.getFullYear();
    let mm = currentDate.getMonth() + 1;
    let dd = currentDate.getDate();
    if (dd < 10) dd = "0" + dd;
    if (mm < 10) mm = "0" + mm;
    const FormatedDate = dd + "/" + mm + "/" + yyyy;
    const DateReverse = FormatedDate.split("/").reverse().join("-");

  return (
    <>
      <div>
        <form onSubmit={handleSubmit(onFinalSubmit)}>
          <div className="card-box personaldetails bottom-25">
            <div className="card-title partner-navlink">Personal Details</div>
            {/* <h3 className="part-title"></h3> */}

            <div className="row">
              <div className="col-md-3 col-sm-3 col-6">
                <div className="form-group">
                  <label className="form-label">
                    Enter Full Name
                    <span className="mandatory-label partner-mandetory">*</span>
                  </label>
                  <input
                    type="text"
                    name="search-text"
                    className="input-st"
                    placeholder="Enter full name"
                    autoComplete="off"
                    maxLength={40}
                    onPaste={handlePaste("nameValid")}
                    {...register("nameValid")}
                    onKeyPress={(e) => {
                      if (!/^[A-Za-z\s]$/.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                  />
                  <p className="forget-link add-error">
                    <span>{errors?.nameValid?.message}</span>
                  </p>
                </div>
              </div>
              <div className="col-md-3 col-sm-3 col-6">
                <div className="form-group">
                  <label className="form-label">
                    Enter PAN number
                    <span className="mandatory-label partner-mandetory">*</span>
                  </label>
                  <input
                    type="text"
                    maxLength={10}
                    name="search-text"
                    className="input-st"
                    onPaste={handlePanPaste}
                    placeholder="Enter PAN number"
                    autoComplete="off"
                    {...register("panValid")}
                    onKeyPress={(e) => validatePan(e)}
                    onInput={NameInput}
                    
                  />
                  <p className="forget-link add-error">
                    <span>{errors?.panValid?.message}</span>
                  </p>
                </div>
              </div>
              <div className="col-md-3 col-sm-3 col-6">
                <div className="form-group">
                  <label className="form-label">
                    Enter Mobile Number
                    <span className="mandatory-label partner-mandetory">*</span>
                  </label>
                  <input
                    type="text"
                    name="search-text"
                    className="input-st"
                    placeholder="Enter mobile umber"
                    autoComplete="off"
                    maxLength={10}
                    pattern="[0-9]*"
                    inputMode="numeric"
                    onPaste={handlePasteDigits("mobileValid", 10)}
                    onKeyPress={(e) => mobileVal(e)}
                    {...register("mobileValid")}
                  />
                  <p className="forget-link add-error">
                    <span>{errors?.mobileValid?.message}</span>
                  </p>
                </div>
              </div>
              <div className="col-md-3 col-sm-3 col-6">
                <div className="form-group">
                  <label className="form-label">
                    Enter Email ID
                    <span className="mandatory-label partner-mandetory">*</span>
                  </label>
                  <input
                    type="text"
                    name="search-text"
                    className="input-st"
                    onPaste={handlePasteEmail}
                    maxLength={35}
                    placeholder="Enter email Id"
                    autoComplete="off"
                    {...register("emailValid")}
                  />
                  <p className="forget-link add-error">
                    <span>{errors?.emailValid?.message}</span>
                  </p>
                </div>
              </div>
              <div className="col-md-3 col-sm-3 col-6">
                <div className="form-group dob-icon">
                  <label className="form-label">
                    Date Of Birth
                    <label className="date-check">(DD-MM-YYYY)</label>
                    <span className="mandatory-label partner-mandetory">*</span>
                  </label>
                  <input
                    type="date"
                    placeholder="DD/MM/YYYY"
                    className="form-control input-st dob-font"
                    {...register("dobValid")}
                    max={DateReverse}
                  />
                  <p className="forget-link add-error">
                    <span>{errors?.dobValid?.message}</span>
                  </p>
                </div>
              </div>
              <div className="col-md-3 col-sm-3 col-6">
                <div className="form-group type-select">
                  <label className="form-label">
                    Type of Gender
                    <span className="mandatory-label partner-mandetory">*</span>
                  </label>

                  <select
                    className="dropdown-select input-st"
                    {...register("genderValid")}
                  >
                    <option value="">Select Gender</option>
                    <option value="M">Male</option>
                    <option value="F">Female</option>
                    <option value="Others">Others</option>
                  </select>

                  <p className="forget-link add-error">
                    <span>{errors?.genderValid?.message}</span>
                  </p>
                </div>
              </div>
              <div className="col-md-3 col-sm-3 col-6">
                <div className="form-group">
                  <label className="form-label">
                    PIN Code
                    <span className="mandatory-label partner-mandetory">*</span>
                  </label>
                  <input
                    type="text"
                    name="search-text"
                    className="input-st"
                    placeholder="Enter pincode"
                    autoComplete="off"
                    {...register("pinCodeValid")}
                    maxLength={6}
                    onPaste={handlePastePincode}
                    onInput={onlyNumber}
                  />
                  <p className="forget-link add-error">
                    <span>{errors?.pinCodeValid?.message}</span>
                  </p>
                </div>
              </div>
              <div className="col-md-3 col-sm-3 col-6">
                <div className="form-group">
                  <label className="form-label">
                    City
                    <span className="mandatory-label partner-mandetory">*</span>
                  </label>
                  <input
                    type="text"
                    name="search-text"
                    className="input-st"
                    placeholder="Select city"
                    autoComplete="off"
                    maxLength={50}
                    {...register("cityValid")}
                  />
                  <p className="forget-link add-error">
                    <span>{errors?.cityValid?.message}</span>
                  </p>
                </div>
              </div>
              <div className="col-md-3 col-sm-3 col-6">
                <div className="form-group">
                  <label className="form-label">
                    State
                    <span className="mandatory-label partner-mandetory">*</span>
                  </label>
                  <input
                    type="text"
                    name="search-text"
                    className="input-st"
                    placeholder="Select state"
                    maxLength={50}
                    autoComplete="off"
                    {...register("stateValid")}
                  />
                  <p className="forget-link add-error">
                    <span>{errors?.stateValid?.message}</span>
                  </p>
                </div>
              </div>
              <div className="col-md-3 col-sm-3 col-6">
                <div className="form-group">
                  <label className="form-label">
                    Address 1
                    <span className="mandatory-label partner-mandetory">*</span>
                  </label>
                  <input
                    type="text"
                    name="search-text"
                    className="input-st"
                    onPaste={handlePasteAddress("add1Valid")}
                    maxLength={50}
                    placeholder="Enter Block Number / Street"
                    autoComplete="off"
                    {...register("add1Valid")}
                  />
                  <p className="forget-link add-error">
                    <span>{errors?.add1Valid?.message}</span>
                  </p>
                </div>
              </div>
              <div className="col-md-3 col-sm-3 col-6">
                <div className="form-group">
                  <label className="form-label">
                    Address 2
                    <span className="mandatory-label partner-mandetory">*</span>
                  </label>
                  <input
                    type="text"
                    name="search-text"
                    className="input-st"
                    maxLength={50}
                    placeholder="Enter landmark"
                    autoComplete="off"
                    onPaste={handlePasteAddress("add2Valid")}
                    {...register("add2Valid")}
                  />
                  <p className="forget-link add-error">
                    <span>{errors?.add2Valid?.message}</span>
                  </p>
                </div>
              </div>
              <div className="col-md-3 col-sm-3 col-6">
                <div className="form-group">
                  <label className="form-label">
                    Address 3
                    <span className="mandatory-label partner-mandetory">*</span>
                  </label>
                  <input
                    type="text"
                    name="search-text"
                    className="input-st"
                    placeholder="Enter address"
                    maxLength={50}
                    onPaste={handlePasteAddress("add2Valid")}
                    autoComplete="off"
                    {...register("add3Valid")}
                  />
                  <p className="forget-link add-error">
                    <span>{errors?.add3Valid?.message}</span>
                  </p>
                </div>
              </div>
              <div className="col-md-3 col-sm-3 col-6">
                <div className="form-group type-select">
                  <label className="form-label">
                    Citizen
                    <span className="mandatory-label partner-mandetory">*</span>
                  </label>
                  <select
                    className="dropdown-select input-st"
                    {...register("citizenValid")}
                  >
                    <option value="">Select Citizenship</option>
                    <option value="India">India</option>
                    <option value="NRI">NRI</option>
                  </select>
                  <p className="forget-link add-error">
                    <span>{errors?.citizenValid?.message}</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="card-box bank-card">
            <div>
              <div className="card-title">Bank & Other Details</div>
              <div className="row">
                <div className="col-md-3 col-sm-3 col-6">
                  <div className="form-group">
                    <label className="form-label">
                      Bank Account Number
                      <span className="mandatory-label partner-mandetory">
                        *
                      </span>
                    </label>
                    <input
                      type="text"
                      maxLength={20}
                      name="search-text"
                      className="input-st"
                      placeholder="Enter account number"
                      autoComplete="off"
                      onPaste={handlePasteAccountNumber}
                      onInput={onlyNumber}
                      {...register("accNumber")}
                    />
                    <p className="forget-link add-error">
                      <span>{errors?.accNumber?.message}</span>
                    </p>
                  </div>
                </div>
                <div className="col-md-3 col-sm-3 col-6">
                  <div className="form-group type-select">
                    <label className="form-label">
                      Type of Account
                      <span className="mandatory-label partner-mandetory">
                        *
                      </span>
                    </label>
                    <select
                      className="dropdown-select input-st"
                      {...register("accType")}
                    >
                      <option value="">Select account type</option>
                      <option value="Saving">Saving</option>
                      <option value="Current">Current</option>
                    </select>
                    <p className="forget-link add-error">
                      <span>{errors?.accType?.message}</span>
                    </p>
                  </div>
                </div>
                <div className="col-md-3 col-sm-3 col-6">
                  <div className="form-group">
                    <label className="form-label">
                      IFSC-Code
                      <span className="mandatory-label partner-mandetory">
                        *
                      </span>
                    </label>
                    <input
                      type="text"
                      maxLength={11}
                      name="search-text"
                      className="input-st"
                      placeholder="Enter IFSC code"
                      autoComplete="off"
                      onPaste={handlePasteIFSC}
                      {...register("ifscCode")}
                      onInput={NameInput}
                      onKeyPress={(e) => {
                        if (!/^[A-Za-z0-9]$/.test(e.key)) {
                          e.preventDefault();
                        }
                      }}

                    />
                    <p className="forget-link add-error">
                      <span>{errors?.ifscCode?.message}</span>
                    </p>
                  </div>
                </div>
                <div className="col-md-3 col-sm-3 col-6">
                  <div className="form-group">
                    <label className="form-label">
                      Bank Name
                      <span className="mandatory-label partner-mandetory">
                        *
                      </span>
                    </label>
                    <input
                      type="text"
                      name="search-text"
                      className="input-st"
                      placeholder="Enter bank name"
                      autoComplete="off"
                      {...register("bankName")}
                      onPaste={handlePaste("bankName")}
                      onInput={NameInput}
                      maxLength={40}
                      onKeyPress={(e) => {
                        if (!/^[A-Za-z\s]$/.test(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />
                    <p className="forget-link add-error">
                      <span>{errors?.bankName?.message}</span>
                    </p>
                  </div>
                </div>
                <div className="col-md-3 col-sm-3 col-6">
                  <div className="form-group calendar-icon">
                    <label className="form-label">
                      Branch Name
                      <span className="mandatory-label partner-mandetory">
                        *
                      </span>
                    </label>
                    <input
                      type="text"
                      placeholder="Enter branch name"
                      className="input-st"
                      maxLength={40}
                      onPaste={handlePaste("branchName")}
                      {...register("branchName")}
                      onKeyPress={(e) => {
                        if (!/^[A-Za-z\s]$/.test(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />
                    <p className="forget-link add-error">
                      <span>{errors?.branchName?.message}</span>
                    </p>
                  </div>
                </div>
                <div className="col-md-3 col-sm-3 col-6">
                  <div className="form-group">
                    <label className="form-label">
                      MICR Number
                      <span className="mandatory-label partner-mandetory">
                        *
                      </span>
                    </label>
                    <input
                      type="text"
                      className="input-st"
                      placeholder="Enter MICR number"
                      autoComplete="off"
                      {...register("micrNumber")}
                      onPaste={handlePasteDigits("micrNumber", 9)}
                      maxLength={9}
                      onKeyPress={(e) => {
                        if (!/^\d$/.test(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />
                    <p className="forget-link add-error">
                      <span>{errors?.micrNumber?.message}</span>
                    </p>
                  </div>
                </div>

                <div className="col-md-3 col-sm-3 col-6">
                  <div className="form-group">
                    <label className="form-label">
                      Client Code
                      <span className="mandatory-label partner-mandetory">
                        *
                      </span>
                    </label>
                    <input
                      type="text"
                      className="input-st"
                      placeholder="Enter Client code"
                      autoComplete="off"
                      maxLength={10}
                      onPaste={handlePasteCodes("clCode")}
                      {...register("clCode")}
                      // onChange={(e)=>{
                      //   let input = e.target.value.toUpperCase()
                      // }}
                      onKeyPress={(e) => {
                        if (!/^[A-Za-z0-9]$/.test(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />
                    <p className="forget-link add-error">
                      <span>{errors?.clCode?.message}</span>
                    </p>
                  </div>
                </div>

                {/* <div className="col-md-3 col-sm-3 col-6">
          <div className="form-group type-select">
            <label className="form-label">Type of Segment
            <span className="mandatory-label">*</span></label>
            <select
              className="dropdown-select input-st"
              {...register("segmentType")}
              >
                <option value="">Select segment type</option>
                <option value="NSE">NSE</option>
                <option value="BSE">BSE</option>
              </select>
                <p className="forget-link add-error"><span>{errors?.segmentType?.message}</span></p>
          </div>
        </div> */}

                <div className="col-md-3 col-sm-3 col-6">
                  <div className="form-group type-select">
                    <label className="form-label">
                      Type of Segment
                      <span className="mandatory-label partner-mandetory">
                        *
                      </span>
                    </label>

                    <div className="form-group multi-select-parent">
                      <div className="rm-custom-dropdown">
                        <input
                          name="branch"
                          placeholder="Select segment type"
                          className="multi-select-input"
                          {...register("segmentType")}
                          onClick={() => {
                            setShowUlResponse(!showUlResponse);
                          }}
                          readOnly
                        />
                        <button
                          type="button"
                          className="rm-dropdown-btn"
                          onClick={() => setShowUlResponse(!showUlResponse)}
                        >
                          <span className="icon-right-arrow-triangle"></span>{" "}
                        </button>
                      </div>
                      {showUlResponse && (
                        <div className="multi-select-common">
                          <ul>
                            {segmentValue.map((item, i) => {
                              return (
                                <div key={i} className="multi-select-wrapper">
                                  <input
                                    type="checkbox"
                                    onClick={(e) => checkBoxClick(e, item)}
                                    defaultChecked={
                                      multiVal.includes(item.segment)
                                        ? true
                                        : false
                                    }
                                  />
                                  <li value={item.segment} className="multi-li">
                                    {item.segment}
                                  </li>
                                </div>
                              );
                            })}
                          </ul>
                        </div>
                      )}
                      <p className="forget-link add-error">
                        <span>{errors?.segmentType?.message}</span>
                      </p>
                    </div>
                  </div>
                </div>

                <div className="col-md-3 col-sm-3 col-6">
                  <div className="form-group">
                    <label className="form-label">
                      Partner Code
                      <span className="mandatory-label partner-mandetory">
                        *
                      </span>
                    </label>
                    <input
                      type="text"
                      name="search-text"
                      className="input-st"
                      placeholder="Enter partner Code"
                      autoComplete="off"
                      {...register("partnerCode")}
                      onPaste={handlePasteCodes("partnerCode")}
                      maxLength={10}
                      onKeyPress={(e) => {
                        if (!/^[A-Za-z0-9]$/.test(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />
                    <p className="forget-link add-error">
                      <span>{errors?.partnerCode?.message}</span>
                    </p>
                  </div>
                </div>
              </div>
              <div className="personal-back-btn">
                <button
                  type="submit"
                  className="back-message"
                  onClick={() => navigate("/partner-admin-dashboard")}
                >
                  Back
                </button>
                <button type="submit" className="back-message signup-btn">
                  {loader ? (
                    <div>
                      <SmallLoader />
                    </div>
                  ) : (
                    <>Save</>
                  )}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
      {/*  transaction modal*/}
      <Modal
        show={deleteTransaction}
        size="lg"
        centered
        backdrop="static"
        keyboard={false}
        className="partner-delete-modal rm-model part-modal"
      >
        <Modal.Body>
          <div className="modal-section text-section">
            <img src={arrowTick} className="arrow-tick" />
            <div className="head-title">
              <h2>Are you Sure?</h2>
              <p className="info-txt">You want to accept the transaction</p>
            </div>
            <div className=" btn-wrapper">
              <button className="del-btn">Delete</button>
              <button
                className="can-btn"
                onClick={() => setDeleteTransaction(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      {/*  */}
      {/* delete modal */}
      <Modal
        show={DeleteRecords}
        size="lg"
        centered
        backdrop="static"
        keyboard={false}
        className="partner-delete-modal rm-model part-modal"
      >
        <Modal.Body>
          <div className="modal-section text-section">
            <img src={DeleteIcon} className="arrow-tick" alt="DeleteIcon" />
            <div>
              <h2 className="head-title">Are you Sure?</h2>
              <p className="info-txt">You want to delete the record</p>
            </div>
            <div className=" btn-wrapper">
              <button className="del-btn-info">Delete</button>
              <button
                className="can-btn"
                onClick={() => setDeleteRecords(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* <BankDetails /> */}
    </>
  );
};

export default PersonalDetails;
